import { render, staticRenderFns } from "./MyImg.vue?vue&type=template&id=33be5faa&scoped=true&"
import script from "./MyImg.vue?vue&type=script&lang=js&"
export * from "./MyImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be5faa",
  null
  
)

export default component.exports